import ParentPageContainer from './ParentPageContainer';

export default ParentPageContainer;
